import { useMemo } from "react";
import { useAppSelector } from "@/core/store";
import { createAppTheme } from "./muiTheme";

// Dynamic Theme Hook - integrates Redux theme state with MUI
export const useDynamicTheme = () => {
  const { theme, customColors } = useAppSelector((state) => state.app);

  // Handle theme mode changes via useColorScheme
  const mode = useMemo(() => {
    switch (theme) {
      case "auto":
        return "light";
      case "custom":
        // Extract mode from customColors if available, otherwise default to light
        return (customColors?.mode as "light" | "dark" | undefined) || "light";
      default:
        return theme;
    }
  }, [theme, customColors]);

  // Only recreate theme when custom colors change
  return useMemo(() => {
    const palette = createAppTheme(mode, customColors);
    return palette;
  }, [customColors, mode]);
};
